// TODO: expand categories according to manifest and property options https://wix.atlassian.net/browse/EP-6442
const MEDIA_CATEGORY_MAP = {
    image: 'IMAGE',
    video: 'VIDEO',
    vectorArt: 'SHAPE_ALL',
};
export class HostMediaSelectorAPI {
    constructor(ps) {
        this.ps = ps;
    }
    async selectMedia(dataItemKey, context) {
        const definition = context.dataDefinitions[dataItemKey];
        // TODO: base mediaCategory on manifest as well https://wix.atlassian.net/browse/EP-6442
        const category = MEDIA_CATEGORY_MAP[definition?.dataType] ?? 'ALL_MEDIA';
        return this.ps.hostAPI.editor.selectMedia({
            // TODO: type should be the updated category options type once it is well defined https://wix.atlassian.net/browse/EP-6442
            category,
        });
    }
}
//# sourceMappingURL=HostMediaSelectorAPI.js.map